// Версия приложения для предотвращения кеширования
// Обновляйте эту версию при каждом деплое
export const APP_VERSION = '1.0.1765391084';

// Функция для добавления версии к URL
export const addVersionToUrl = (url) => {
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}v=${APP_VERSION}`;
};

// Функция для обновления приложения
export const forceAppUpdate = () => {
  if ('caches' in window) {
    caches.keys().then(names => {
      names.forEach(name => {
        caches.delete(name);
      });
    });
  }
  
  // Очистка localStorage
  localStorage.clear();
  
  // Перезагрузка с обходом кеша
  window.location.reload(true);
};
